$(document).ready(function () {

  function initSliders() {
    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });
  }

  function destroySliders() {
    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      if ($(slider).hasClass('slick-initialized')) {
        $(slider).slick('unslick');
      }
    });
  }

  // init on load
  initSliders();

  // re-init on resize (debounced)
  let resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      destroySliders();
      initSliders();
    }, 300); // debounce
  });

});

 $(document).on("click", ".el-play-button", function (e) {
     var video = jQuery(this).parents('.el-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.el-video-wrapper').removeClass('active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.el-video-wrapper').addClass('active');
     jQuery(this).addClass('active');
 }
 });



 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});



$(document).on("click", ".el-question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.el-question').removeClass('active');
    jQuery('.el-question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});



$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#faq']", function (e) {
  e.preventDefault();
  document.querySelector('#faq').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#benefits']", function (e) {
  e.preventDefault();
  document.querySelector('#benefits').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#testimonials']", function (e) {
  e.preventDefault();
  document.querySelector('#testimonials').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.el-listicle-section3 .el-image-with-text-column2').scrollIntoView({
    behavior: 'smooth'
  })
});


$(document).on("click", ".el-mobile-menu-button", function (e) {
    $('.el-drawer-menu').addClass('active');
    $('.el-drawer-menu-bg').show();
    $('body').addClass('el-overflow-hidden');
});
$(document).on("click", ".el-mobile-menu-close", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});

$(document).on("click", ".el-drawer-menu-bg", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});



function isAtViewportMidline(el) {
  if (!el || !el.getBoundingClientRect) return false;
  if (!$(el).is(':visible')) return false;

  const rect = el.getBoundingClientRect();
  const vw = window.innerWidth || document.documentElement.clientWidth;
  const vh = window.innerHeight || document.documentElement.clientHeight;
  const midY = vh / 2;

  // horizontally on-screen AND the element spans the middle line
  return rect.left < vw && rect.right > 0 && rect.top < midY && rect.bottom > midY;
}

function runCounters($block) {
  $block.addClass('el-start-count');
  $block.find('.el-count-js').each(function () {
    const $c = $(this);
    const target = +($c.data('value') || 0);
    $c.prop('Counter', 0).stop(true).animate(
      { Counter: target },
      {
        duration: 2000,
        easing: 'swing',
        step: function (now) { $c.text(Math.ceil(now)); }
      }
    );
  });
}

function checkCountersInView() {
  $('.el-element-counter').each(function () {
    const $block = $(this);
    if ($block.hasClass('el-start-count')) return;          // only once
    if (isAtViewportMidline(this)) runCounters($block); // trigger when truly visible
  });
}

$(window).on('scroll load', checkCountersInView);


  function isScrolledIntoView2(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
docViewBottom = docViewBottom-($(window).height()/2)+($(elem).height())+100;
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom));
}

$(window).scroll(function () {
    $('.el-timeline-grid-item').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('el-active');
        } else {
          $(this).removeClass('el-active');
        }
    });
});










  function refreshAndOpenRebuyCart2() {
  if (!window.Rebuy) return;

  Rebuy.Cart.fetch();       // refresh data
  Rebuy.SmartCart.show();   // open drawer
}

$(document).on("click", ".el-cart-button", function (e) {
    refreshAndOpenRebuyCart2();
});
// MAIN OPTION CLICK
$(document).on('click', '.el-product .el-element-option', function () {
  var $this = $(this);
  var $parent = $this.closest('.el-product');
  var tab = parseInt($this.attr('data_tab'), 10);

  if (!tab) return;

  // Active state
  $parent.find('.el-element-option').removeClass('el-active');
  $this.addClass('el-active');

  // Toggle quantity UI
  $parent.find('.el-quantity-trigger').hide();
  $parent.find('.el-quantity-trigger[data_tab="' + tab + '"]').show();

  $parent.find('.el-checkout-button').attr('quantity',tab);
 
});


// SUB OPTION CLICK (when NOT active)
$(document).on('click', '.el-product .el-element-sub-option:not(.el-active)', function () {
  var $this = $(this);
  var $parent = $this.closest('.el-product');
  var tab = parseInt($this.attr('sub_tab'), 10);
  var selling_plan = $this.attr('selling_plan');

  if (!tab) return;

  // Active state
  $parent.find('.el-element-sub-option').removeClass('el-active');
  $this.addClass('el-active');

  // Toggle UI
  $parent.find('.el-sub-trigger').hide();
  $parent.find('.el-sub-trigger[sub_tab="' + tab + '"]').show();
  $parent.find('.el-checkout-button').attr('selling_plan',selling_plan);
});


// SUB OPTION CLICK (when already active → toggle to other)
$(document).on('click', '.el-product .el-element-sub-option.el-active', function () {
  var $parent = $(this).closest('.el-product');

  var $other = $parent.find('.el-element-sub-option:not(.el-active)');
  var tab = parseInt($other.attr('sub_tab'), 10);

  if (!tab) return;

  // Switch active
  $parent.find('.el-element-sub-option').removeClass('el-active');
  $other.addClass('el-active');

  // Toggle UI
  $parent.find('.el-sub-trigger').hide();
  $parent.find('.el-sub-trigger[sub_tab="' + tab + '"]').show();
  $parent.find('.el-checkout-button').removeAttr('selling_plan');
});










$(document).on("click", "a[href='#show']", function (e) {
  e.preventDefault();
    $('.el-review-widget .el-element-review-card:nth-child(3)~*').slideToggle();
    $(this).parents('.el-read-reviews').hide();
    $('.el-read-reviews:has(a[href="#hide"])').show();
});


$(document).on("click", "a[href='#hide']", function (e) {
  e.preventDefault();
    $('.el-review-widget .el-element-review-card:nth-child(3)~*').slideToggle();
    $(this).parents('.el-read-reviews').hide();
    $('.el-read-reviews:has(a[href="#show"])').show();
});


